class MobileMenuSlide extends HTMLElement {
  constructor() {
    super();

    this.header = document.querySelector('.header');
    this.drawer = this.querySelector('[data-mobile-menu-drawer]');
    
    this.addEventListener('click', (e) => {
      const openBtn = e.target.closest('.js-open-submenu');
      const closeBtn = e.target.closest('.js-close-submenu');

      // Handle submenu open
      if (openBtn) {
        const submenuId = openBtn.getAttribute('aria-controls');
        const submenu = document.getElementById(submenuId);

        if (submenu) {
          submenu.hidden = false;
          requestAnimationFrame(() => {
            submenu.classList.add('is-active');
          });
          openBtn.setAttribute('aria-expanded', 'true');

          // Add header class if NOT first tier
          const level = submenu.dataset.menuLevel;
          if (level && level !== '1') {
            this.header?.classList.add('mobile-menu--submenu-open');
          }
        }
      }

      // Handle submenu close
      if (closeBtn) {
        const submenu = closeBtn.closest('[data-menu-submenu]');
        if (submenu) {
          submenu.classList.remove('is-active');
          submenu.addEventListener(
            'transitionend',
            () => {
              submenu.hidden = true;
            },
            { once: true }
          );

          const openButton = this.querySelector(`.js-open-submenu[aria-controls="${submenu.id}"]`);
          if (openButton) {
            openButton.setAttribute('aria-expanded', 'false');
          }

          // Check if any submenus are still open (except tier 1)
          const stillOpen = this.querySelector('[data-menu-submenu].is-active[data-menu-level]:not([data-menu-level="1"])');
          if (!stillOpen) {
            this.header?.classList.remove('mobile-menu--submenu-open');
          }
        }
      }
    });

    // ESC to close all submenus
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' || e.keyCode === 27) {
        const activeSubmenus = this.querySelectorAll('[data-menu-submenu].is-active');
        activeSubmenus.forEach((submenu) => {
          submenu.classList.remove('is-active');
          submenu.addEventListener(
            'transitionend',
            () => {
              submenu.hidden = true;
            },
            { once: true }
          );

          const openButton = this.querySelector(`.js-open-submenu[aria-controls="${submenu.id}"]`);
          if (openButton) {
            openButton.setAttribute('aria-expanded', 'false');
          }
        });

        // Remove header class when closing all
        this.header?.classList.remove('mobile-menu--submenu-open');
      }
    });
  }
}

if (!customElements.get('mobile-menu-slide')) {
  customElements.define('mobile-menu-slide', MobileMenuSlide);
}
